import { SearchTerm } from "./SearchTerm";

const LiftSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "liftName",
        translationKey: "name"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "building.site.siteName",
        translationKey: "site"
    },
    {
        heading: "Building",
        accessor: "building",
        searchOnName: "building.buildingName",
        translationKey: "building"
    },
];

export default LiftSearch;
